import type { Creature } from '@/domain/creature/types';
import { normalizeCareProfile } from './profile';

export type CareTrait =
  | 'well-fed'
  | 'spoiled'
  | 'playful'
  | 'messy'
  | 'resilient'
  | 'disciplined'
  | 'rebellious'
  | 'heavy'
  | 'frail'
  | 'athletic'
  | 'comfort-seeker'
  | 'curious';

export function deriveCareTraits(creature: Creature): CareTrait[] {
  const profile = normalizeCareProfile(creature.careProfile);
  const traits: CareTrait[] = [];

  if (profile.healthyMeals + profile.heartyMeals >= profile.snacks + 3 && profile.healthyMeals + profile.heartyMeals >= 3) {
    traits.push('well-fed');
  }
  if (profile.snacks >= profile.healthyMeals + profile.heartyMeals + 3 && profile.snacks >= 3) {
    traits.push('spoiled');
  }
  if (profile.plays >= 4) traits.push('playful');
  const dominantPlayCount = Math.max(profile.activePlays, profile.comfortPlays, profile.focusPlays);
  if (dominantPlayCount >= 4) {
    if (profile.activePlays === dominantPlayCount) traits.push('athletic');
    else if (profile.comfortPlays === dominantPlayCount) traits.push('comfort-seeker');
    else traits.push('curious');
  }
  if (profile.lateCleanups >= 2) traits.push('messy');
  if (profile.heals > 0) traits.push('resilient');
  if (profile.correctDisciplines >= profile.wrongDisciplines + 2 && profile.correctDisciplines >= 2) {
    traits.push('disciplined');
  }
  if (profile.wrongDisciplines >= profile.correctDisciplines + 2 || profile.refusals >= 8) {
    traits.push('rebellious');
  }
  if (creature.state.weight >= 80) traits.push('heavy');
  if (profile.sickTimeMs >= 30 * 60 * 1000) traits.push('frail');

  return traits;
}
